<template>
  <section>
    <div class="row mt-5">
      <div class="col-12">
        <h1 class="sales-page-title text-center">ออฟฟิศของคุณมีปัญหาแม่บ้านแบบนี้ไหม</h1>
      </div>
    </div>
    <section class="section-padding-home">
      <div class="row">
        <div class="col-12">
          <img src="/static/img/sales/cover.jpg" alt="บีนีทแม่บ้านออนไลน์ ทำความสะอาด" class="img-fluid">
        </div>
      </div>
    </section>

    <section class="section-padding-home mt-5 text-center">
      <h2 class="sales-page-title">เรียกคุณแม่บ้าน BeNeat ไปแทน แบบไม่ต้องจ้างประจำ</h2>
      <div class="row mt-5">
        <div class="col-md-3">
          <div class="card -bg-grey">
            <div class="card-body">
              <div class="my-4">
                <img src="/static/img/sales/ic-group.png" alt="บีนีทแม่บ้านออนไลน์ ทำความสะอาด" height="80">
              </div>
              <label class="mt-3">
                บีนีทมีแม่บ้านในระบบกว่า 1,000 คนที่พร้อมให้บริการได้ทันที ไม่ต้องห่วงเรื่องวันลา<br><br>
              </label>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="card -bg-grey">
            <div class="card-body">
              <div class="my-4">
                <img src="/static/img/sales/ic-cerificate.png" alt="บีนีทแม่บ้านออนไลน์ ทำความสะอาด" height="80">
              </div>
              <label class="mt-3">
                คุณแม่บ้านทุกท่านผ่านการอบรมจากบีนีท ทั้งภาคทฤษฎีและปฏิบัติ ดังนั้นคุณภาพรับประกัน<br><br>
              </label>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="card -bg-grey">
            <div class="card-body">
              <div class="my-4">
                <img src="/static/img/sales/ic-time.png" alt="บีนีทแม่บ้านออนไลน์ ทำความสะอาด" height="80">
              </div>
              <label class="mt-3">
                สามารถจ้างรายชั่วโมงได้ เลือกจ้างเฉพาะวันที่จำเป็นต้องใช้จริงๆเท่านั้น ทำให้ประหยัดค่าจ้างแม่บ้านประจำไปได้
              </label>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="card -bg-grey">
            <div class="card-body">
              <div class="my-4">
                <img src="/static/img/sales/ic-vat.png" alt="บีนีทแม่บ้านออนไลน์ ทำความสะอาด" height="80">
              </div>
              <label class="mt-3">
                สามารถออกใบเสร็จและใบกำกับภาษีได้ทุกงานหมดห่วงเรื่องเอกสารทางบัญชี<br><br>
              </label>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section-padding-home mt-5 text-center">
      <h2 class="sales-page-title">วางใจในคุณภาพมาตรฐานสากล</h2>
      <div class="row mt-5">
        <div class="col-12 col-md-8 offset-md-6">
          <h2 class="sales-page-title" style="color: #212121 !important;">
            มีการฝึกอบรมมาตรฐานสากล และทั้งภาคทฤษฎีและภาคปฎิบัติและมอบประกาศนียบัตรแก่ผู้ผ่านการอบรมหลักสูตรสากล
          </h2>
        </div>
      </div>
      <div class="row mt-5">
        <div class="col-12 img-center">
          <img src="/static/img/sales/standard01.jpg" alt="บีนีทแม่บ้านออนไลน์ ทำความสะอาด" class="img-fluid">
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-md-5 col-12 mb-4">
          <img src="/static/img/sales/standard02.jpg" alt="บีนีทแม่บ้านออนไลน์ ทำความสะอาด" class="img-fluid ">
        </div>
        <div class="col-md-7 col-12 mb-4">
          <img src="/static/img/sales/standard03.jpg" alt="บีนีทแม่บ้านออนไลน์ ทำความสะอาด"
               class="img-fluid float-right">
        </div>
      </div>
    </section>


    <section class="section-padding-home mt-5 text-center">
      <h2 class="sales-page-title">คุณค่าที่คุณจะได้รับ</h2>
      <div class="row mt-5">
        <div class="col-md-4">
          <div class="card -bg-grey">
            <div class="card-body">
              <img src="/static/img/sales/ic-benefit01.png" alt="บีนีทแม่บ้านออนไลน์ ทำความสะอาด" height="42">
              <h3>ยืดหยุ่น</h3>
              <label>
                ไม่จำเป็นต้องทำสัญญาจ้างระยะยาว<br>เหมือนบริษัททำความสะอาดทั่วไป
              </label>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="card -bg-grey">
            <div class="card-body">
              <img src="/static/img/sales/ic-benefit02.png" alt="บีนีทแม่บ้านออนไลน์ ทำความสะอาด" height="42">
              <h3>คล่องตัว</h3>
              <label>
                ปรับเปลี่ยน, เพิ่ม-ลด การจอง<br>ได้ตลอดเวลาตามที่สะดวก
              </label>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="card -bg-grey">
            <div class="card-body">
              <img src="/static/img/sales/ic-benefit03.png" alt="บีนีทแม่บ้านออนไลน์ ทำความสะอาด" height="42">
              <h3>อุ่นใจ</h3>
              <label>
                มีประกันความเสียหาย<br>100,000 บาท ในทุกการจอง
              </label>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="card -bg-grey">
            <div class="card-body">
              <img src="/static/img/sales/ic-benefit04.png" alt="บีนีทแม่บ้านออนไลน์ ทำความสะอาด" height="42">
              <h3>มีใบกำกับภาษี</h3>
              <label>
                สามารถออกเอกสาร<br>เพื่อลงเป็นต้นทุนของบริษัท
              </label>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="card -bg-grey">
            <div class="card-body">
              <img src="/static/img/sales/ic-benefit05.png" alt="บีนีทแม่บ้านออนไลน์ ทำความสะอาด" height="42">
              <h3>เครื่องมือ-น้ำยา</h3>
              <label>
                แม่บ้านไปให้บริการพร้อมเครื่องมือ-น้ำยา<br>อุปกรณ์ทำความสะอาดครบครัน
              </label>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="card -bg-grey">
            <div class="card-body">
              <img src="/static/img/sales/ic-benefit06.png" alt="บีนีทแม่บ้านออนไลน์ ทำความสะอาด" height="42">
              <h3>ประหยัดค่าใช้จ่าย</h3>
              <label>
                จองบริการทำความสะอาด<br>ตามขนาดธุรกิจของคุณ
              </label>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section-padding-home text-center">
      <div class="row">
        <div class="col-12">
          <img src="/static/img/sales/pricing.jpg" alt="บีนีทแม่บ้านออนไลน์ ทำความสะอาด" class="img-fluid"
               style="width: 100%;">
        </div>
      </div>
    </section>

    <section class="section-padding-home text-center">
      <section-partner />
      <div class="row">
        <div class="col-md-6">
          <div class="embed-responsive embed-responsive-16by9 mt-4">
            <iframe width="560"
                    height="315"
                    src="https://www.youtube.com/embed/RTbcjC9Udzg"
                    frameborder="0"
                    allow="autoplay; encrypted-media"
                    allowfullscreen></iframe>
          </div>
        </div>
        <div class="col-md-6">
          <div class="embed-responsive embed-responsive-16by9 mt-4">
            <iframe width="560"
                    height="315"
                    src="https://www.youtube.com/embed/xCGWH7JU83M"
                    frameborder="0"
                    allow="autoplay; encrypted-media"
                    allowfullscreen></iframe>
          </div>
        </div>
      </div>
    </section>

    <!-- Section Contact Us -->
    <section class="section-padding-home mt-5">
      <div class="row">
        <div class="col-md-12 text-center">
          <h1 style="color: #ff0019;">แพ็คเกจโปรโมชั่น จำนวนจำกัด!</h1>
          <h2 style="color: #ff0019;">เริ่มต้นเพียงเดือนละ <span
            style="background-color: #ffde28;">&nbsp;2,033&nbsp;</span> บาท</h2>
        </div>
      </div>
      <div class="row mt-5">
        <div class="col-md-12 text-center">
          <h2>สนใจติดต่อ</h2>
          <div class="business-contact">
            <div class="mb-3">
              <i class="fas fa-phone-square text-primary"></i>
              <a href="tel:021131138">02-113-1138</a>
            </div>
            <div class="mt-3">
              <!-- <a href="https://line.me/R/ti/p/%40hnk7011n" target="_blank">
                <img height="38" alt="Line BeNeat" src="/static/img/btn-line.png">
              </a> -->
              <a href="https://line.me/R/ti/p/@BeNeat" target="_blank">
                <img height="38" alt="Line BeNeat" src="/static/img/btn-line.png">
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-5 text-center">
        <h3>{{ $t('message.hero.or') }}</h3>
      </div>
      <div class="row mt-5">
        <div class="col-lg-6 offset-lg-3">
          <div class="card -bg-grey">
            <div class="card-body">
              <div class="my-4">
                <h3 class="text-center" style="color: #ff0019;">ลงชื่อรับสิทธิโปรโมชั่นทันที</h3>
              </div>
              <div class="form">
                <div class="form-group">
                  <label for="name">{{ $t('message.business.contact_name') }}*</label>
                  <input type="text"
                         class="form-control input-jumbo"
                         id="name"
                         ref="name"
                         v-model="contactData.name"
                         required>
                </div>
                <div class="form-group">
                  <label for="company_name">{{ $t('message.business.contact_company_name') }}*</label>
                  <input type="text"
                         class="form-control input-jumbo"
                         id="company_name"
                         ref="company_name"
                         v-model="contactData.company_name"
                         required>
                </div>
                <div class="form-group">
                  <label for="email">{{ $t('message.business.contact_province') }}*</label>
                  <input type="text"
                         class="form-control input-jumbo"
                         id="province"
                         ref="province"
                         v-model="contactData.province"
                         required>
                </div>
                <div class="form-group">
                  <label for="email">{{ $t('message.business.contact_email') }}*</label>
                  <input type="email"
                         class="form-control input-jumbo"
                         id="email"
                         ref="email"
                         v-model="contactData.email"
                         required>
                </div>
                <div class="form-group">
                  <label for="tel">{{ $t('message.business.contact_tel') }}*</label>
                  <input type="tel"
                         class="form-control input-jumbo"
                         id="tel"
                         ref="tel"
                         v-model="contactData.tel"
                         required>
                </div>
              </div>
              <button class="button button-large button-block -cyan"
                      @click="sendEmail"> {{ $t(isSending) }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>

  </section>
</template>

<script>
  import { mapGetters } from 'vuex'
  import SectionPartner from '../../SectionPartner.vue'
  export default {
    components: {
      SectionPartner
    },
    data () {
      return {
        contactData: {
          from: 'Sales Page',
          name: '',
          company_name: '',
          province: '',
          email: '',
          tel: ''
        }
      }
    },
    computed: {
      ...mapGetters({
        isSendingEmail: 'business/getIsSendingEmail',
        isSending: 'business/isSending'
      })
    },
    watch: {
      isSendingEmail () {
        if (!this.isSendingEmail) {
          this.contactData = {
            name: '',
            company_name: '',
            email: '',
            tel: ''
          }
          this.$router.push('/thank')
          /*
          this.$swal({
            type: 'success',
            title: this.$i18n.t('message.business.thank_you'),
            text: this.$i18n.t('message.business.contact_you_soon')
          })
          */
        }
      }
    },
    methods: {
      validation () {
        let result = true
        const emailFormat = new RegExp('^([a-z0-9\\+_\\-]+)(\\.[a-z0-9\\+_\\-]+)*@([a-z0-9\\-]+\\.)+[a-z]{2,6}$')
        if (this.contactData.name === '') {
          this.$refs.name.focus()
          result = false
        } else if (this.contactData.company_name === '') {
          this.$refs.company_name.focus()
          result = false
        } else if (this.contactData.province === '') {
          this.$refs.province.focus()
          result = false
        } else if (this.contactData.email === '') {
          this.$refs.email.focus()
          result = false
        } else if (this.contactData.email && !emailFormat.test(this.contactData.email)) {
          this.contactData.email = ''
          this.$refs.email.focus()
          result = false
        } else if (this.contactData.tel === '') {
          this.$refs.tel.focus()
          result = false
        } else {
          result = true
        }
        return result
      },
      sendEmail () {
        if (this.validation()) {
          this.$store.dispatch('business/SEND_EMAIL', this.contactData)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/information/sales/SalesBusiness.vue